import { useState } from "react";
import { FlightUpdateForm } from "@/components/organization/FlightUpdateForm";
import { CreateFlightDialog } from "@/components/organization/CreateFlightDialog";

const UpdateFlightsPage = () => {
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <div className="container mx-auto px-4 py-8">
      <FlightUpdateForm key={refreshKey} />
    </div>
  );
};

export default UpdateFlightsPage;
